export default "__VITE_ASSET__ByQ9Rm33__"